/**
 * Shared in-memory cache for team members.
 * Populated by TeamContacts via refreshTeamFromApi().
 * Read by TasksService via getTeamMembersCache().
 */

export interface CachedTeamMember {
  id: string;
  name: string;
  email?: string;
  isActive?: boolean;
  // Real data since TeamContacts.refreshTeamFromApi() always populates it —
  // this type just hadn't caught up, so callers had no typed way to filter
  // assignees by team.
  teams?: string[];
}

let teamMembersCache: CachedTeamMember[] = [];

export function getTeamMembersCache(): CachedTeamMember[] {
  return teamMembersCache;
}

export function setTeamMembersCache(members: CachedTeamMember[]): void {
  teamMembersCache = members;
}
